import { render, staticRenderFns } from "./accident.vue?vue&type=template&id=09b91dab&scoped=true&"
import script from "./accident.vue?vue&type=script&lang=js&"
export * from "./accident.vue?vue&type=script&lang=js&"
import style0 from "./accident.vue?vue&type=style&index=0&id=09b91dab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b91dab",
  null
  
)

export default component.exports